import React from "react";
import { useForm, useWatch } from "react-hook-form";
import Input from "./Input";
import { resolver } from "./schema";
import MaskedInput from "./MaskedInput";
import "./styles.scss";
import { Button } from "reactstrap";

const ContactForm = ({ onSubmit, onCancel }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm({ resolver: resolver });
  const messageVal = useWatch({
    control,
    name: "message",
  });

  const submitHandler = handleSubmit((data) => {
    onSubmit(data);
  });

  return (
    <form className="contact-form" onSubmit={submitHandler}>
      <Input
        label="Name"
        required
        type="text"
        placeholder="Contact name"
        name="name"
        errors={errors.name}
        {...register("name")}
      />
      <Input
        label="Email"
        required
        type="email"
        placeholder="Contact email"
        name="email"
        errors={errors.email}
        {...register("email")}
      />
      <MaskedInput
        label="Phone"
        type="tel"
        placeholder="(___) ___-____"
        name="phone"
        mask="(999) 999-9999"
        errors={errors.phone}
        {...register("phone")}
      />
      <Input
        label="Message"
        type="textarea"
        placeholder="Contact message"
        name="message"
        errors={errors.message}
        countLabel={`${1000 - (messageVal?.length ?? 0)} characters left`}
        maxLength="1000"
        {...register("message")}
      />
      <div>
        <Button color="link" type="button" onClick={onCancel}>
          Cancel
        </Button>
        <Button color="primary" type="submit">
          Message Agent
        </Button>
      </div>
    </form>
  );
};

export default ContactForm;
